import {
    ActiveFarmTypography
  } from '../../components/CustomStyles/StyledComponents';
export default function SelectedFarm({ farmId , farmName }) {
    return(
        farmId && farmName ?
        <ActiveFarmTypography style={{ fontWeight:'bold', marginBottom:'5px'}}>Active Farm :  <span style={{ fontWeight:'normal' }}>{ farmName }</span> </ActiveFarmTypography> :
        <ActiveFarmTypography style={{ fontWeight:'bold', marginBottom:'5px'}}>Active Farm :  <span style={{ fontWeight:'normal' }}>{ "No farm selected" }</span> </ActiveFarmTypography>
    );
}